import React from 'react'
import { List } from 'lucide-react'
import { Divider } from '@mui/material'


export default function CustomInput({ label, placeholder, value, onChange, icon, onBlur, type, required, disabled }) {
  return (
    <div className="w-full min-w-[200px] ">
      <div className="bg-white rounded-[12px] shadow-sm border border-gray-200 p-3 flex items-center space-x-4">
        <div className="flex-shrink-0">
          <span className="h-6 w-6 text-orange-500">{icon}</span>
        </div>
        <Divider orientation="vertical" flexItem style={{ margin: '0px 8px' }} />
        <div style={{ marginLeft: '0px' }}>
          <label htmlFor="input-field" className="block text-sm font-medium text-gray-700">
            {label}{required && <span className="text-red-400"> *</span>}
          </label>
          <input
            type={type}
            id="input-field"
            className="mt-1 block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}